<template>
    <div class="article-item-simple">
        <router-link
            :to="{ name: 'article-detail', params: { slug: data.slug } }"
            class="article-item-simple-title"
        >
            {{ data.title }}
        </router-link>
        <div class="article-item-simple-date">
            {{ data.createdDate | moment('DD/MM/YYYY') }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'ArticleItemSimple',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'ArticleItemSimple';
</style>
